import { format } from "date-fns";

import {
  FAQS,
  UPGRADES_CARDS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_ADD_ON,
  PRE_PURCHASE_FAQS_BY_PASS_ID,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  TERMS_AND_CONDITIONS_BY_PASS_ID,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";
import { routes } from "src/shared/routes";
import { calcOptOutDate } from "src/utils/utils";
import giftBannerImageDesktop from "public/images/sacramentokings_pass/gift-page-banner-desktop.jpg";
import giftBannerImageMobile from "public/images/sacramentokings_pass/gift-page-banner-mobile.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const sacramentokings_pass: TTeamConfig = {
  TEAM_SCHEMA: "sacramentokings_pass",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Kings Pass",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#63727A",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,

    DISABLE_STANDARD_PURCHASE_ON_GIFT_PASSES: true,
  },

  UPGRADES_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    UPGRADES_CARDS,
  },

  BUNDLE_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  BUNDLE_DETAILS_PAGE_SETTINGS: {
    PASS: {
      SHOW_FAQ_BUTTON: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,
    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      SHOW_FAQ_BUTTON: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_MULTIPLE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE: (
        <>
          You will be able to view and manage your subscriptions after{" "}
          <b>
            {format(calcOptOutDate(new Date("10/01/2024")), "MMMM dd, yyyy")}
          </b>
          .
          <br />
          <br />
          If your Kings Pass is a part of an annual plan, it will auto-renew
          monthly through the end of the 2026-2027 regular season. Please note
          that there is no option to cancel this subscription.
        </>
      ),
    },
  },

  GIFT_PAGE_SETTINGS: {
    IS_ENABLED: true,
    BANNER: {
      IMAGE_URL: giftBannerImageDesktop.src,
      IMAGE_URL_MOBILE: giftBannerImageMobile.src,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
    PASS: {
      HIDE_SUBSCRIBE_BUTTON: true,
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento%20Kings%20Marketing%20Assets/Attend%20Desktop%20-%201920x450_KINGS%20PASS.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento Kings Marketing Assets/Attend Mobile - 375x550_KINGS PASS.jpg",
    MOBILE_BUNDLE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento Kings Marketing Assets/Attend Mobile - 375x550_KINGS PASS.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento%20Kings%20Marketing%20Assets/Attend%20Desktop%20-%201920x450_KINGS%20PASS.jpg",
    BUNDLE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento%20Kings%20Marketing%20Assets/Attend%20Desktop%20-%201920x450_KINGS%20PASS.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/kings-v3-assets/BACKGROUND IMAGE_1.jpg",
    UPGRADE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento%20Kings%20Marketing%20Assets/Attend%20Desktop%20-%201920x450_KINGS%20PASS.jpg",
    MOBILE_UPGRADE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Sacramento Kings Marketing Assets/Attend Mobile - 375x550_KINGS PASS.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_ADD_ON,
    PRE_PURCHASE_FAQS_BY_PASS_ID,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    TERMS_AND_CONDITIONS_BY_PASS_ID,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  },
};
